import React, { useState, useContext } from "react"
import { useTranslation } from "react-i18next"
import { DropdownUI, LabelUI, ItemUI, MenuChevronDown, MenuChevronUp } from "./style"
import { SessionContext } from "../../services/context"
import ResultLanguageContext from "../../services/context/ResultLanguageContext"
import TrackingManager from "../../services/tracking"

const labels = {
  en: "EN",
  de: "DE",
  es: "ES",
  fr: "FR",
  it: "IT",
  pt: "PT",
  nl: "NL",
  ja: "JA",
  vi: "VN",
  zh: "中文",
  pl: "PL",
  sv: "SV",
  ar: "AR",
}

const Item = ({ language }) => {
  return (
    <ItemUI>
      <LabelUI>{labels[language]}</LabelUI>
    </ItemUI>
  )
}

const allLanguageOptions = [
  { value: "en", content: <Item language="en" /> },
  { value: "de", content: <Item language="de" /> },
  { value: "es", content: <Item language="es" /> },
  { value: "fr", content: <Item language="fr" /> },
  { value: "it", content: <Item language="it" /> },
  { value: "pt", content: <Item language="pt" /> },
  { value: "nl", content: <Item language="nl" /> },
  { value: "ja", content: <Item language="ja" /> },
  { value: "vi", content: <Item language="vi" /> },
  { value: "zh", content: <Item language="zh" /> },
  { value: "pl", content: <Item language="pl" /> },
  { value: "sv", content: <Item language="sv" /> },
  { value: "ar", content: <Item language="ar" /> },
]

const selectIcons = [<MenuChevronDown />, <MenuChevronUp />]

const SelectLanguage = (props) => {
  const { i18n } = useTranslation()
  const { availableLanguages, resultLanguage, setResultLanguage } = useContext(ResultLanguageContext)

  const isResultMode = availableLanguages && availableLanguages.length > 0
  const activeLanguage = isResultMode ? resultLanguage : i18n.language.substring(0, 2)

  const [icon, setIcon] = useState(selectIcons[0])

  let session, sessionId, deviceId
  session = useContext(SessionContext)
  sessionId = session.sessionId
  deviceId = session.deviceId

  const changeLanguage = (selected) => {
    if (activeLanguage !== selected) {
      const trackingManager = new TrackingManager()
      trackingManager.track({
        event: "Language Changed",
        data: {
          deviceId,
          sessionId,
          language: selected,
        },
      })

      if (isResultMode) {
        setResultLanguage(selected)
      } else {
        i18n.changeLanguage(selected)
      }
    }
  }

  const handleOnOpen = () => {
    setIcon(selectIcons[1])
  }

  const handleOnClose = () => {
    setIcon(selectIcons[0])
  }

  const options = isResultMode
    ? allLanguageOptions.filter(({ value }) => availableLanguages.includes(value))
    : allLanguageOptions

  const visibleOptions = options.filter(({ value }) => value !== activeLanguage)

  if (isResultMode && availableLanguages.length <= 1) {
    return null
  }

  const trigger = <Item language={activeLanguage} />

  return (
    <DropdownUI
      icon={icon}
      trigger={trigger}
      options={visibleOptions}
      onOpen={handleOnOpen}
      onClose={handleOnClose}
      onChange={changeLanguage}
    />
  )
}

export default SelectLanguage
